import Subscribtion from '~/web-frontend-core/base/Subscribtion';
import { toURL } from '~/web-frontend-core/base/Tool';
import Logger from '~/web-frontend-core/devtools/logger';
import { ChampionshipsStates } from '~/web-frontend-core/store/line/matchesList/Championships';
import { ListenersManager } from '~/web-frontend-core/store/line/matchesList/ListenersManager';
import { MatchesStates } from '~/web-frontend-core/store/line/matchesList/Matches';
import { SportsStates } from '~/web-frontend-core/store/line/matchesList/Sports';
import { OutcomesDesktop, OutcomesMobile, OutcomesMobileLine } from '~/web-frontend-core/store/line/Outcomes';
import { COLUMN_WIDTH } from '~/web-frontend-core/api/const/base';
/** Т.к результаты singleton, используем константный ID */
const subscriptionID = 0;
export class MatchesListBase extends Subscribtion {
    constructor(cfg) {
        super();
        this.subscribedIDs = new Set();
        this.championships = new ChampionshipsStates();
        this.matches = new MatchesStates();
        this.sports = new SportsStates();
        this.isLoading = false;
        this.isLoadingListeners = [];
        this.width = cfg.width || COLUMN_WIDTH.MEDIUM;
        this.update = this.update.bind(this);
        this.listenersManager = new ListenersManager(cfg);
        this.outcomes = new (cfg.isMobile ? OutcomesMobile : OutcomesDesktop)(cfg);
        this.outcomesLine = new OutcomesMobileLine(cfg);
    }
    setIsLoadingListener(cb) {
        this.isLoadingListeners.push(cb);
    }
    removeIsLoadingListener(cb) {
        this.isLoadingListeners = this.isLoadingListeners.filter(_cb => _cb !== cb);
    }
    notifyIsLoadingListeners(state) {
        this.isLoadingListeners.forEach(cb => cb(state));
    }
    setIsLoading(state) {
        this.isLoading = state;
        try {
            this.notifyIsLoadingListeners(state);
        }
        catch (_a) {
            // ignore errors
        }
    }
    getData(filter) {
        const { sortedSportIds, sports } = this.sports.getData();
        if (sports && Object.keys(sports).length === 0) {
            return null;
        }
        const matches = this.matches.getData(filter);
        if (Object.keys(matches).length === 0) {
            return null;
        }
        return {
            sortedSportIds,
            championships: this.championships.getData(filter),
            diff: false,
            matches,
            sports,
        };
    }
    toggleChampionships() {
        this.championships.isAllUnfolded() ? this.championships.foldAll() : this.championships.unfoldAll();
        this.notify();
    }
    setToggleChampionships(state) {
        if (state) {
            this.championships.unfoldAll();
        }
        else {
            this.championships.foldAll();
        }
        this.notify();
    }
    //#region WS
    reinit(cfg) {
        this.listenersManager = new ListenersManager(cfg);
        this.outcomes = new (cfg.isMobile ? OutcomesMobile : OutcomesDesktop)(cfg);
        this.outcomesLine = new OutcomesMobileLine(cfg);
        if (this.isSubscribed() && this.lastQuery) {
            this.stopListenWS();
            this.listenWS(this.lastQuery);
        }
    }
    /**
     * Подписка на обновления таблицы live доп.исходов через WS
     */
    listenWS(cfg) {
        this.lastQuery = cfg;
        this.setIsLoading(true);
        const logger = Logger.getInstance();
        return new Promise((resolve, reject) => {
            const onerror = (e) => {
                logger.error(e);
                this.stopListenWS();
                reject(e);
            };
            const onopen = () => {
                this.subscribedIDs.add(subscriptionID);
                this.setIsLoading(false);
                // logger.log('[MatchesListBase: Список Live матчей] Соединение открыто');
                resolve();
            };
            const config = Object.assign(Object.assign({}, cfg), { subscriptionID, onmessage: this.update, onerror,
                onopen });
            this.listenersManager.subscribe(config);
        });
    }
    stopListenWS() {
        this.setIsLoading(false);
        if (this.isLoading) {
            this.notify();
        }
        if (!this.isSubscribed) {
            return;
        }
        this.subscribedIDs.delete(subscriptionID);
        // this.listenersManager.unsubscribe({ subscriptionID });
    }
    clear() {
        this.sports.clear();
        this.championships.clear();
        this.matches.clear();
        this.outcomes.clear();
        this.outcomesLine.clear();
        this.notify();
    }
    isSubscribed() {
        return this.subscribedIDs.has(subscriptionID);
    }
    //#endregion
    setWidth(width) {
        if (this.width === width) {
            return;
        }
        this.width = width;
        this.outcomes.setWidth(width);
        this.outcomesLine.setWidth(width);
        this.notify();
    }
    update(data) {
        if ('diff' in data) {
            this.matches.update(data.matches, data === null || data === void 0 ? void 0 : data.headTables);
            this.championships.update(data.championships);
            this.sports.setData(data.sports, data.sortedSportIds);
            this.setIsLoading(false);
            this.notify();
            return;
        }
        if (data.matches) {
            this.matches.update(data.matches);
        }
        if (data.championships) {
            this.championships.update(data.championships);
        }
        if (data.sports) {
            this.sports.update(data.sports);
        }
        if (data.sortedSportIds) {
            this.sports.updateSortedIDs(data.sortedSportIds);
        }
        this.setIsLoading(false);
        this.notify();
    }
    static getSportURL(mode, sport) {
        return `/${mode}/${sport.enSport ? toURL(sport.enSport) : sport.sportID}`;
    }
    static getChampionshipURL(mode, sport, championship) {
        return `${this.getSportURL(mode, sport)}/${toURL(`${championship.championshipID}${championship.enChampionship && `_${championship.enChampionship}` || ''}`)}`;
    }
    static getMatchURL(mode, sport, championship, match) {
        return `${this.getChampionshipURL(mode, sport, championship)}/${!match.teams.enTeam1 ? match.matchID : toURL(`${match.matchID}${match.teams.enTeam1 && `_${match.teams.enTeam1} ${match.teams.enTeam2}` || ''}`)}`;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/matchesList/Base.js